export default __webpack_public_path__ + "static/media/boleta.208e4d66.png";